//#region STYLES
import "./EventsStatus.scss";
//#endregion

//#region COMPONENTS
import Donut from "../../Elements/Donut/Donut";
//#endregion

//#region UTILS
import { groupBy } from "../../../tools";
import { useTranslation } from "react-i18next";
//#endregion

export default function EventsStatus({ eventStatus }: any) {
  //TRANSLATION INIT
  const { t } = useTranslation();

  eventStatus = Object.keys(eventStatus).length > 0 ? groupBy(eventStatus, 'status') : {};

  const data = [
    { value: eventStatus["Registered"]?.length ?? 0.0001, name: t("dashboard.registered"), color: "#2ADD9D" },
    { value: eventStatus["In Progress"]?.length ?? 0.0001, name: t("dashboard.inProgress"), color: "#7C4DFF" },
    { value: eventStatus["Cancelled"]?.length ?? 0.0001, name: t("dashboard.cancelled"), color: "#167FFC" },
    { value: eventStatus["Transferred"]?.length ?? 0.0001, name: t("dashboard.transferred"), color: "#034799" }
  ];

  return (
    <div className="EventsStatus">
      <h3 className="EventsStatus__title">{t("dashboard.eventsStatus")}</h3>
      {/* DONUT CHART */}
      <Donut
        options={data}
        radius={85}
        hole={60}
        labels={true}
        percent={false}
        strokeWidth={0}
        stroke={"#fff"}
      />
    </div>
  );
}
